import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import routes from '../../routes';
import { ScenarioPropType } from '../shared/propTypes';

const ScenarioLinkCellRenderer = ({
  data: { scenarioId, scenarioName },
  showLink,
}) => {
  const scenarioLink = useMemo(() =>
    routes.scenarios.MEMBERS_LIST.replace(/:scenarioId/, scenarioId),
  [scenarioId]
  );

  if (!showLink) {
    return scenarioName;
  }

  return (
    <Link to={scenarioLink}>
      { scenarioName }
    </Link>
  );
};


ScenarioLinkCellRenderer.propTypes = {
  data: ScenarioPropType,
  showLink: PropTypes.bool,
};

export default ScenarioLinkCellRenderer;
